import { BankAccount, PaymentMethod, WirePaymentMethod } from 'types/payment';

export const isBankPaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is BankAccount => {
	return Object.hasOwn(paymentMethod ?? {}, 'routingNumber');
};

export const isWirePaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is WirePaymentMethod => {
	return Object.hasOwn(paymentMethod ?? {}, 'wirePaymentMethodId');
};
